import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef, useBreakpointValue, useColorMode, } from '@chakra-ui/react';
import { theme } from '../../../modules/theme';
import { DEFAULT_PROPS } from './types';
export { AccentCardContent } from './AccentCardContent';
export { AccentCardDescription } from './AccentCardDescription';
export { AccentCardFooter } from './AccentCardFooter';
export { AccentCardTitle } from './AccentCardTitle';
export const AccentCard = forwardRef(({ colorScheme: responsiveColorScheme = DEFAULT_PROPS.colorScheme, variant: responsiveVariant = DEFAULT_PROPS.variant, ...props }, ref) => {
    const { colorMode } = useColorMode();
    const colorScheme = (useBreakpointValue(responsiveColorScheme) ??
        responsiveColorScheme);
    const variant = useBreakpointValue(responsiveVariant) ?? responsiveVariant;
    return (_jsx(Flex, { ref: ref, flexDirection: { base: 'column', lg: 'row' }, alignItems: { base: 'start', lg: 'center' }, justifyContent: { base: 'center', lg: 'start' }, borderColor: theme.colors[colorMode].border[3], borderStyle: "solid", borderWidth: variant === 'outline' ? theme.sizes['0.5'] : 0, bg: theme.colors[colorMode].layer[2].default, borderRadius: theme.sizes['8'], boxShadow: `0px ${theme.sizes[1]} 0px 0px ${theme.colors[colorMode].support[colorScheme][3]}, ${theme.colors[colorMode].shadow[4]}`, transition: "transform 0.4s ease-in-out", _hover: {
            transform: 'scale(0.95)',
        }, ...props }));
});
